<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá abrir e controlar a avaliação das startups na
              chamada. Para sua abertura é necessário preencher as informações
              inicias abaixo e definir as perguntas da ficha de avaliação. Após
              a criação, é possível gerenciar o status da avaliação.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12">
          <call-card v-if="call" :call="call" />
        </div>
      </div>
      <div class="row mb-6">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3
                    class="mb-0 d-flex align-items-center justify-content-between"
                  >
                    <div>
                      Avaliação da chamada
                      <span class="text-warning">{{ call.name }}</span>
                    </div>
                    <base-button
                      v-if="evaluation"
                      type="default"
                      class="float-right"
                      @click="
                        $router.push(
                          `/admin/avaliacoes/${evaluation.id}/respostas`
                        )
                      "
                      ><i class="fas fa-eye mr-2"></i>Visualizar
                      respostas</base-button
                    >
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent class="vld-parent">
                <h6 class="heading-small text-muted mb-4">Detalhes</h6>
                <div class="pl-lg-2">
                  <div class="col">
                    <i class="fas fa-rocket mr-2 text-warning"></i>
                    <span>Startups inscritas na chamada: </span>
                    <badge type="info" class="p-2 bg-white"
                      ><span
                        v-if="subscriptions_count"
                        class="font-weight-600"
                        >{{ subscriptions_count }}</span
                      ><span class="text-warning" v-else
                        >nenhuma inscrição até o momento</span
                      ></badge
                    >
                    <base-button
                      type="secondary"
                      @click="
                        $router.push(
                          `/admin/chamadas/${$route.params.id}/inscricoes`
                        )
                      "
                      size="sm"
                      class="float-right"
                      :custom="true"
                      >Gerenciar inscrições</base-button
                    >
                  </div>
                  <div class="col mt-3">
                    <i class="fas fa fa-user-tie mr-2 text-primary"></i>
                    <span>Investidores vinculados ao fundo: </span>
                    <badge type="info" class="p-2 bg-white"
                      ><span v-if="investors_count" class="font-weight-600">{{
                        investors_count
                      }}</span
                      ><span class="text-warning" v-else
                        >não há investidores cadastrados</span
                      ></badge
                    >
                    <base-button
                      type="secondary"
                      @click="
                        $router.push(
                          `/admin/fundos/${call.fund_id}/investidores`
                        )
                      "
                      size="sm"
                      class="float-right"
                      :custom="true"
                      >Gerenciar investidores</base-button
                    >
                  </div>
                </div>
                <hr class="my-4" />
                <div v-if="evaluation">
                  <h6 class="heading-small text-muted">Informações básicas</h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="form-control-label"
                          >Data de inicío da avaliação</label
                        >
                        <p>{{ formatDate(evaluation.date) }}</p>
                      </div>
                      <div class="col-lg-6">
                        <label class="form-control-label">
                          Status da avaliação
                        </label>
                        <p>
                          <i
                            class="fas fa-info-circle mr-1"
                            :title="currentStatus.description"
                          ></i>
                          {{ currentStatus.value }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2 mb-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Perguntas para avaliação
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div
                      class="row mb-2"
                      v-for="(
                        question, index
                      ) in evaluation.evaluationQuestions"
                      :key="index"
                    >
                      <div class="col-12 mb-2">
                        <span class="form-control-label">
                          Pergunta {{ index + 1 }}
                        </span>
                      </div>
                      <p class="pl-4">
                        <i class="fas fa-arrow-right"></i> {{ question.title }}
                        <span class="text-muted"
                          >({{ question.description }})</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="text-center mt-1">
                    <base-alert type="danger" v-if="error" class="mb-4">{{
                      error
                    }}</base-alert>
                    <base-button type="white" @click="handleDeleteEvaluation"
                      ><i class="fas fa-trash mr-1 text-danger"></i> Excluir
                      avaliação</base-button
                    >
                    <base-button
                      type="white"
                      @click="handleChangeEvaluationStatus"
                      ><i class="fas fa-globe mr-1 text-info"></i> Alterar
                      status da avaliação</base-button
                    >
                  </div>
                </div>
                <div v-else-if="subscriptions_count && investors_count">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                  <div class="pl-lg-4">
                    <div class="row">
                      <div class="col-lg-6">
                        <label class="form-control-label"
                          >Data de inicío da avaliação</label
                        >
                        <base-input
                          type="date"
                          addon-left-icon="ni ni-calendar-grid-58"
                          placeholder="Data"
                          input-classes="form-control"
                          v-model="model.date"
                        />
                      </div>
                      <div class="col-lg-6">
                        <label class="form-control-label">
                          Status da avaliação
                        </label>
                        <div>
                          <base-input addon-left-icon="fas fa-cogs">
                            <select class="form-control" v-model="model.status">
                              <option selected disabled value="">
                                Selecione o status da avaliação
                              </option>
                              <option
                                v-for="status in evaluationStatus"
                                :key="'new_status_' + status.key"
                                :value="status.key"
                              >
                                {{ status.value }}
                              </option>
                            </select>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="my-4" />
                  <h6 class="heading-small text-muted mb-4">
                    Perguntas para avaliação
                  </h6>
                  <div class="pl-lg-4 pl-md-0">
                    <div
                      class="row mb-4"
                      v-for="(question, index) in questions"
                      :key="index"
                    >
                      <div class="col-12">
                        <div
                          class="mb-2 d-flex align-items-center justify-content-between"
                        >
                          <span class="form-control-label"
                            >Pergunta {{ index + 1 }}</span
                          >
                          <base-button
                            type="link"
                            class="text-danger"
                            :iconOnly="true"
                            icon="fas fa-times"
                            @click="handleRemoveQuestion(index)"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <textarea
                          rows="2"
                          class="form-control form-control"
                          placeholder="Título da pergunta"
                          v-model="question.title"
                        ></textarea>
                      </div>
                      <div class="col-lg-6 mt-2 mt-lg-0">
                        <textarea
                          rows="2"
                          class="form-control form-control"
                          placeholder="Digite aqui uma breve descrição para instruir o investidor a responder a pergunta"
                          v-model="question.description"
                        >
                        </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3 text-right">
                    <base-button
                      type="link"
                      @click="handleAddDefaultQuestions"
                      size="sm"
                      >Adicionar perguntas padrão</base-button
                    >
                    <base-button
                      @click="handleAddNewQuestion"
                      size="sm"
                      :custom="true"
                      >Adicionar nova pergunta</base-button
                    >
                  </div>
                  <div class="text-center mt-4">
                    <base-alert type="danger" v-if="error" class="mb-4">{{
                      error
                    }}</base-alert>
                    <base-button
                      type="primary"
                      @click="handleOpenEvaluation"
                      :disabled="!isValidModel"
                      ><i class="fas fa-globe mr-1"></i> Abrir chamada para
                      avaliação dos investidores</base-button
                    >
                  </div>
                </div>
                <div v-else class="col-12 text-center">
                  <base-alert class="mt-2" type="danger">
                    Para gerenciar as perguntas e abrir a chamada para avaliação
                    dos investidores é preciso que a chamada esteja em um fundo
                    com investidores cadastrados e existam startups inscritas no
                    processo seletivo.
                  </base-alert>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalOpen"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-globe fa-3x"></i>
        <h4 class="heading mt-4">
          Você realmente deseja abrir avaliação da chamada
          <span class="text-warning">{{ this.call.name }}</span
          >?
        </h4>
        <p class="mt-3 mb-0">
          <i class="fas fa-info-circle mr-1"></i> Ao confirmar, os
          <b class="text-warning font-weight-600"
            >{{ investors_count }} investidores</b
          >
          cadastrados no fundo dessa chamada poderão avaliar as
          <b class="text-warning font-weight-600"
            >{{ subscriptions_count }} startups</b
          >
          inscritas.
        </p>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalOpen = false"
        >
          Voltar
        </base-button>
        <base-button type="white" @click="handleSubmitOpenEvaluation">
          Confirmar
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modalRemove"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-globe fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a avaliação da chamada
            <span class="text-warning">{{ call.name }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Se existirem, todas as avaliações dos investidores das startups
            inscritas nessa chamada serão perdidas.
          </p>
          <p class="mt-3">
            Por favor, digite
            <span class="text-warning font-weight-bold">{{ call.name }}</span>
            para prosseguir
          </p>
          <base-input
            placeholder="Digite aqui"
            input-classes="form-control"
            addon-left-icon="fas fa-trash text-warning"
            v-model="modals.inputConfirmation"
          />
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalRemove = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveEvaluation"
          :disabled="!inputConfirmationTextIsValid()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modalChange"
      gradient="default"
      modal-classes="modal-warning modal-dialog-centered"
      v-if="modals.newStatus"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-globe fa-3x"></i>
        <h4 class="heading mt-4">
          Avaliação da chamada
          <span class="text-warning">{{ this.call.name }}</span>
        </h4>
        <p class="mt-3 mb-0">
          Atualmente a avaliação está com status
          <span class="text-warning">{{ currentStatus.value }}</span
          >. Para alterá-lo, selecione um novo status:
        </p>
        <div class="mt-2">
          <base-input addon-left-icon="fas fa-cogs">
            <select class="form-control" v-model="modals.newStatus">
              <option selected disabled value="">
                Selecione o status da avaliação
              </option>
              <option
                v-for="status in evaluationStatus"
                :key="'updt_status_' + status.key"
                :value="status.key"
              >
                {{ status.value }}
              </option>
            </select>
          </base-input>
        </div>
        <div class="text-muted text-sm">
          <i class="fas fa-info-circle mr-1"></i>
          {{
            evaluationStatus.find((status) => status.key === modals.newStatus)
              .description
          }}
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalChange = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          @click="handleSubmitEvaluationStatus"
          :disabled="currentStatus.key == modals.newStatus"
        >
          Alterar status
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

import CallCard from "@/components/CallCard";

export default {
  name: "avaliacao",
  components: {
    CallCard,
  },
  data() {
    return {
      model: {
        status: "",
        date: "",
      },
      evaluation: "",
      questions: [
        {
          title: "",
          description: "",
        },
      ],
      defaultQuestions: [
        {
          title: "Valor ao cliente",
          description:
            "A solução entrega valor significativo ao cliente. Indica o motivo pelo qual o cliente utiliza a solução.",
        },
        {
          title: "Maturidade da solução",
          description:
            "Indica o quanto a solução está pronta para ser oferecida ao mercado, com processo de vendas estruturado e escalável.",
        },
        {
          title: "Vantagem competitiva",
          description:
            "A solução é substancialmente melhor que as outras opções disponíveis no mercado, difícil de ser substituída e difícil de ser imitada.",
        },
        {
          title: "Viabilidade técnica e de produção",
          description:
            "A solução foi desenvolvida pela Startup que busca por implementar melhorias constantes na solução oferecida. Há disponibilidade de recursos para produzir a solução oferecida.",
        },
        {
          title: "Atratividade de Mercado e de investimentos",
          description:
            "O mercado tem tamanho significativo, não está saturado de outras soluções, tem comportamento cíclico ou perene. E é atrativo para novos investidores.",
        },
      ],
      call: "",
      subscriptions_count: "",
      investors_count: "",
      empty: false,
      evaluationStatus: [
        {
          key: "open",
          value: "Aberta",
          description:
            "Uma avaliação aberta fica visível para os investidores, que podem avaliar as startups inscritas.",
        },
        {
          key: "closed",
          value: "Encerrada",
          description:
            "Uma avaliação encerrada pode ser visualizada no histórico, porém o investidor não pode realizar novas avaliações.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma avaliação invisível fica oculta para todos os investidores, não aparecendo nem mesmo em seu histórico.",
        },
      ],
      currentStatus: {
        key: "",
        value: "",
        description: "",
      },
      modals: {
        modalOpen: false,
        modalChange: false,
        newStatus: "",
        modalRemove: false,
        inputCofirmation: "",
      },
      error: "",
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      width: 200,
      height: 200,
    });
    try {
      const { data: evaluation } = await api.get(
        `/adm/startup-calls/${this.$route.params.id}/evaluations`
      );
      if (evaluation) {
        this.evaluation = evaluation;
        this.questions = evaluation.evaluationQuestions;
        this.currentStatus = this.evaluationStatus.find(
          (status) => status.key === evaluation.status
        );
      }
      const {
        data: { call, subscriptions_count, investors_count },
      } = await api.get(
        `/adm/startup-calls/${this.$route.params.id}?count=true`
      );
      if (call.sectors) call.sectors = call.sectors.split(";").filter((s) => s);
      this.call = call;
      this.subscriptions_count = subscriptions_count;
      this.investors_count = investors_count;
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações da chamada"
      );
      this.$router.push("/admin/chamadas");
    } finally {
      loader.hide();
    }
  },
  methods: {
    async handleSubmitOpenEvaluation() {
      this.error = "";
      const validQuestions = [];
      this.questions.forEach((question) => {
        if (question.title && question.description)
          validQuestions.push(question);
      });
      const loader = this.$loading.show({
        width: 200,
        height: 200,
      });
      try {
        await api.post(`/adm/evaluations`, {
          ...this.model,
          startup_call_id: this.$route.params.id,
          questions: validQuestions,
        });
        this.$toasted.show("Avaliação da chamada aberta com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao abrir a chamada. Tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.modalOpen = false;
      } finally {
        loader.hide();
      }
    },
    async handleSubmitRemoveEvaluation() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/evaluations/${this.evaluation.id}`);
        this.$toasted.show("Avaliação da chamada removida com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao remover a avaliação da chamada.";
        this.$toasted.error(this.error);
        this.modals.modalRemove = false;
      } finally {
        loader.hide();
      }
    },
    async handleSubmitEvaluationStatus() {
      const loader = this.$loading.show({
        width: 200,
        height: 200,
      });
      try {
        await api.put(`/adm/evaluations/${this.evaluation.id}`, {
          status: this.modals.newStatus,
        });
        this.$toasted.show("Status da avaliação atualizado com sucesso");
        this.$router.push("/admin/chamadas");
      } catch (e) {
        this.error = "Ocorreu um erro ao alterar o status da avaliação.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.modalChange = false;
      } finally {
        loader.hide();
      }
    },
    handleAddNewQuestion() {
      this.questions.push({ title: "", description: "" });
    },
    handleAddDefaultQuestions() {
      if (
        this.questions[0] &&
        !this.questions[0].title &&
        !this.questions[0].description
      )
        this.questions.shift();
      this.questions.push.apply(this.questions, this.defaultQuestions);
    },
    handleRemoveQuestion(index) {
      this.questions.splice(index, 1);
    },
    handleOpenEvaluation() {
      this.modals.modalOpen = true;
    },
    handleDeleteEvaluation() {
      this.modals.inputCofirmation = "";
      this.modals.modalRemove = true;
    },
    handleChangeEvaluationStatus() {
      this.modals.newStatus = this.currentStatus.key;
      this.modals.modalChange = true;
    },
    inputConfirmationTextIsValid() {
      return this.modals.inputConfirmation === this.call.name;
    },
  },
  computed: {
    isValidModel() {
      const data = this.model;
      for (const key in data) {
        if (data[key] === "") return false;
      }
      return true;
    },
  },
};
</script>
